export var REPORTS_LIST_PAGE_SIZE_OPTIONS = [
    5,
    10,
    20,
    30,
    50
];
export var DEFAULT_REPORTS_LIST_PAGE_SIZE = 20;
export var ELLIPSIS = "...";
export var START_WORKFLOW_STATE = "START";
export var SLASH = "/";
export var BACKEND_SYNC_DELAY = 2000;
export var MERIDIAN_DATE_FORMAT = "yyyy-MM-dd";
export var UI_DATE_FORMAT = "dd/MM/yyyy";
export var SP_PERFORMANCE_MANAGEMENT = "SP_PERFORMANCE_MANAGEMENT";
// TODO: To remove Until all config get supported in report config, using check based on term until then
export var EXCEL_INVOICE_REPORTS = "EXCEL_INVOICE_REPORTS";
export var FREQUENCY_TO_POLL_GET_MILLI_SECS = 5000;
export var MAX_ALLOWED_POLLS_BEFORE_TIMEOUT = 36;

//# sourceMappingURL=index.js.map